<template>
    <div class="stream-dreams-2019">
        <div class="container-fluid">
            <MiniHero />
            <build-tabs />
        </div>
        <VideoSection />
        <video-modal
            :key="videoConfig.id"
            :src="videoConfig.src"
        />
    </div>
</template>

<script>
import MiniHero from "./components/hero-section";
import BuildTabs from "./components/build-tabs";
import VideoSection from "./components/video-section";
import VideoModal from "./components/video-modal";

export default {
    name: "StreamPromo",
    components: {
        MiniHero,
        BuildTabs,
        VideoSection,
        VideoModal
    },
    data () {
        return {
            videoConfig: {
                id: 'nzxt-video',
                src: 'https://www.youtube.com/embed/tfArxJ9JpPM'
            }
        }
    }
}
</script>
